import { Card, Col, Row, Button, Pagination, Spin, App } from "antd";
import { DELETE, GET } from "../../utils/apicalls"; // Adjust the path as needed
import { API } from "../../config/api"; // Adjust the path as needed
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const CourseCardView = ({ CourseFilterData, allCategoryData }: any) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 8;
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const { notification } = App.useApp();
    const courseList = CourseFilterData.length ? CourseFilterData : allCourseData;
    const feacthAllCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthAllCourse();
    }, []);
    // Pagination logic
    const paginatedData = courseList.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_COURSE}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: "Course deleted successfully!" });
                feacthAllCourse();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this course?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };
    if (isLoading) return <Spin tip="Loading..." size="large" />;

    return (
        <>
            <Row gutter={[16, 16]}>
                {paginatedData.map((course: any, index: number) => {
                    const category = allCategoryData.find((cat: any) => cat.id === course.category_id);
                    return (
                        <Col key={course.id} xs={24} sm={12} md={8} lg={6}>
                            <Card
                                title={`${(currentPage - 1) * pageSize + index + 1}. ${course.course_title}`}
                                cover={
                                    course.course_image ? (
                                        <img
                                            alt="Course"
                                            src={course.course_image}
                                            style={{ height: 150, objectFit: "cover" }}
                                        />
                                    ) : null
                                }
                                actions={[
                                    <Button type="link" onClick={() => navigate(`/Admin/admincourse/updateCourse/${course.id}`)}>Edit</Button>,
                                    <Button type="link" onClick={() => confirmDelete(course.id)}>Delete</Button>,
                                ]}
                            >
                                <p><strong>Subcourse:</strong> {course.subcourse_title}</p>
                                <p><strong>Price:</strong> ₹{course.course_price}</p>
                                <p><strong>Category:</strong> {category ? category.categoryTitle : 'Unknown'}</p>
                                <p><strong>Duration:</strong> {course.course_duration}</p>

                                <p><strong>Certificate:</strong><br />
                                    {course.course_certificate_image ? (
                                        course.course_certificate_image.toLowerCase().endsWith(".pdf") ? (
                                            <a href={course.course_certificate_image} target="_blank" rel="noopener noreferrer">View PDF</a>
                                        ) : (
                                            <img src={course.course_certificate_image} alt="Certificate" style={{ width: 50, height: 50 }} />
                                        )
                                    ) : 'N/A'}
                                </p>

                            </Card>
                        </Col>
                    );
                })}
            </Row>

            <div style={{ marginTop: 24, textAlign: 'center' }}>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={courseList.length}
                    onChange={(page) => setCurrentPage(page)}
                />
            </div>
        </>
    );
};

export default CourseCardView;
